/** @format */
import { Injectable } from '@angular/core';
import { TranslationMarkupRendererFactory } from 'ngx-transloco-markup';
import { HtmlElementTranspiler } from '../common/html-element-transpiler';

export const OL_START = new (class OlStart {})();
export const OL_END = new (class OlEnd {})();

@Injectable()
export class OlTranspiler extends HtmlElementTranspiler {
    constructor(private readonly rendererFactory: TranslationMarkupRendererFactory) {
        super({
            rendererFactory,
            start: {
                search: '<ol>',
                token: OL_START,
            },
            end: {
                search: '</ol>',
                token: OL_END,
            },
            elementTag: 'ol',
        });
    }
}
